import { styled } from "@mui/system";
import { useSwitch } from "@mui/core/SwitchUnstyled";
import clsx from "clsx";
import euroIcon from "../../images/pound.png";
import cfIcon from "../../images/cf-icon.svg";

/* Custom Swtich Code Starts */
const SwitchRoot = styled("span")(`
  display: inline-block;
  position: relative;
  padding: 1rem 0.5rem;
`);
const SwitchTrack = styled("span")(
  ({ theme }) => `
  background-color: ${theme.palette.mode === "dark" ? "#8796A5" : "#E7E7E7"};
  border-radius: 10px;
  width: 50px;
  height: 22px;
  display: block;
`
);
const SwitchThumb = styled("span")(
  ({ theme }) => `
  position: absolute;
  display: block;
  background-color: ${theme.palette.mode === "dark" ? "#003892" : "#003910"};
  width: 32px;
  height: 32px;
  border-radius: 16px;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1);

  &:before {
    display: block;
    content: "";
    width: 100%;
    height: 100%;
    background-image: url('${euroIcon}');
    background-size:45%;
    filter: invert(1);
    background-position:center;
    background-repeat:no-repeat;
  }

  &:after{
    display: inline-block;
    content: "";
    position: absolute;
    left: 100%;
    top: 0;
    filter: invert(1);
    opacity:0.5;
    width: 60%;
    height: 100%;
    background-image: url('${cfIcon}');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }


  &.focusVisible {
    background-color: #79B;
  }
  &.checked {
    transform: translate(28px, -50%);
    
    &:before {
      background-size:50%;
    filter: none;
      background-image: url(${cfIcon});
      background-size:75%;
    }

    &:after{
      left: -45%;
      width: 35%;
      filter: none;
      transform: translateX(0);
      background-image: url('${euroIcon}');
    }
  }
`
);
const SwitchInput = styled("input")(`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 1;
  margin: 0;
  cursor: pointer;
`);

function MUISwitch(props) {
  const { getInputProps, checked, disabled, focusVisible } = useSwitch(props);
  const stateClasses = {
    checked,
    disabled,
    focusVisible,
  };

  return (
    <SwitchRoot className={clsx(stateClasses)} onClick={props.handleClick}>
      <SwitchTrack>
        <SwitchThumb className={clsx(stateClasses)} />
      </SwitchTrack>
      <SwitchInput {...getInputProps()} aria-label="Toggle Spending Layout" />
    </SwitchRoot>
  );
}
/* Custom Swtich Code Ends */
export default MUISwitch;
